import styles from "../Select.module.css";
import { MembershipLabel } from "./MembershipLabel";
import type { components } from "../../../../../types/schema-lending";

type Membership = components["schemas"]["Membership"];

function MembershipDetails({ membership }: { membership: Membership }) {
  return (
    <div className={styles.membershipDetails}>
      <span className={styles.membershipDot} aria-hidden="true" />
      <MembershipLabel displayName={membership.display_name} />
    </div>
  );
}

export { MembershipDetails };
